// React Components
import React from "react";

// Material UI Components
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';


// Function to insert our Keyword selector (textfield).
export default function KeywordSelector(props){

    const { tenantId, selectedKeyword, setSelectedKeyword, selectedKeywordValue, errorSelectedKeyword } = props;

    return(
        
        <Grid item xs={12}>
            {/* User input field control. */}
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: '140px minmax(0, 600px)' }, gap: { xs: 1, sm: 0 }, width: '100%' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <b>Keyword Search:</b>
                </Box>
                <Box sx={{ minWidth: 0 }}>
                    <TextField                        
                        required
                        name="Keyword Search Text Field"
                        id="keywordTextfield"
                        placeholder="Enter a keyword to search for."
                        variant="outlined"
                        size="small"
                        fullWidth
                        inputProps={{ maxLength: 100 }}
                        InputLabelProps={{ shrink: true }}
                        onChange={event => setSelectedKeyword(event.target.value)}
                        inputRef={selectedKeywordValue}
                        value={selectedKeyword}
                        error={errorSelectedKeyword}
                        helperText={errorSelectedKeyword ? 'Keyword Search cannot be empty.' : ''}                     
                    />
                </Box>
            </Box>
        </Grid>
    );
};
